/** Sentinel leadId for purchasing PO attachment viewers (annotations/markup). */
export const PURCHASING_VIEWER_LEAD_ID = '__purchasing__';

const PURCHASE_ATTACHMENT_DOCUMENT_RE = /^purchase:([^:]+):(.+)$/;

/** Stable document key for a PO attachment (survives Storage URL token refresh). */
export function buildPurchaseAttachmentDocumentId(
  prId: string,
  storagePath: string,
): string {
  const id = (prId || '').trim();
  const path = (storagePath || '').trim().replace(/^\/+/, '');
  return `purchase:${id}:${path}`;
}

export function parsePurchaseAttachmentDocumentId(
  documentId?: string | null,
): { prId: string; storagePath: string } | null {
  const match = PURCHASE_ATTACHMENT_DOCUMENT_RE.exec((documentId || '').trim());
  if (!match) return null;
  return { prId: match[1], storagePath: match[2] };
}

export function isPurchaseAttachmentDocumentId(documentId?: string | null): boolean {
  return parsePurchaseAttachmentDocumentId(documentId) != null;
}

export function isPurchasingViewerLeadId(leadId?: string | null): boolean {
  return (leadId || '').trim() === PURCHASING_VIEWER_LEAD_ID;
}

export function buildPurchaseAttachmentViewerPath(params: {
  prId: string;
  documentId?: string;
  annotationId?: string;
  pageNumber?: number;
}): string {
  const query = new URLSearchParams();
  query.set('pr', params.prId);
  if (params.documentId?.trim()) query.set('file', params.documentId.trim());
  if (params.annotationId?.trim()) query.set('comment', params.annotationId.trim());
  if (params.pageNumber != null && !Number.isNaN(Number(params.pageNumber))) {
    query.set('page', String(params.pageNumber));
  }
  return `/purchasing?${query.toString()}`;
}

export function purchaseAttachmentViewerPathFromNotification(notification: {
  documentId?: string;
  leadId?: string;
  sourceId?: string;
  pdfPageNumber?: number;
}): string | null {
  const parsed = parsePurchaseAttachmentDocumentId(notification.documentId);
  if (parsed) {
    return buildPurchaseAttachmentViewerPath({
      prId: parsed.prId,
      documentId: notification.documentId,
      annotationId: notification.sourceId,
      pageNumber: notification.pdfPageNumber,
    });
  }
  return isPurchasingViewerLeadId(notification.leadId) ? '/purchasing' : null;
}
